// extracted by mini-css-extract-plugin
export var actionButton = "_j1-t";
export var buttonContainer = "_j1-0";
export var buttonContainer2 = "_j1-1";
export var buttonSection = "_j1-2";
export var details = "_j1-3";
export var dropdownItem = "_j1-5";
export var dropdownItemsContainer = "_j1-4";
export var fileInput = "_j1-r";
export var headerButton = "_j1-6";
export var icon = "_j1-7";
export var input = "_j1-8";
export var macroListItem = "_j1-9";
export var mainContent = "_j1-a";
export var microText = "_j1-b";
export var modal = "_j1-w";
export var optionsButton = "_j1-c";
export var paperclip = "_j1-s";
export var pillContent = "_j1-d";
export var preview = "_j1-e";
export var preview2 = "_j1-f";
export var quillEditor = "_j1-q";
export var selectedMacro = "_j1-g";
export var sidebar = "_j1-h";
export var sidebarHeader = "_j1-j";
export var sidebarList = "_j1-i";
export var sidebarListItem = "_j1-k";
export var sidebarSearch = "_j1-l";
export var snoozeDurationWrapper = "_j1-v";
export var statusPillContainer = "_j1-m";
export var tagsContainer = "_j1-n";
export var unselectedMacro = "_j1-o";
export var variable = "_j1-u";
export var wrapper = "_j1-p";